import { useState } from "react";
import { Tooltip, Grid, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import AutoInputIATA from "./../AutoInputIATA";
import { ToastMessage } from "../../../global/ToastMessage";
import useCatalogos from "../../../hooks/useCatalogos";
import { useDispatch } from "react-redux";
import {
  obtenerVuelosByIdPaqueteAction,
  altaVueloCatalogoAction,
} from "./../../../ducks/vueloDuck";
import { altaPaqueteVueloAction } from "./../../../ducks/paqueteDuck";
import BackDrop from "./../../../global/BackDrop";
import useGetAPI from "../../../hooks/useGetAPI";
const AltaVuelo = (props) => {
  const { origen, IdPaquete = 0, ClavePaquete="" } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [destino, setDestino] = useState({ IdCodigo: 0 });
  const catalogoIATA = useCatalogos("IATA");
  const [isLoad, setIsload] = useState(false);
  const [redondo, setRedondo] = useState(false);
  const [proveedor, setProveedor] = useState("");
  const catProveedores = useGetAPI(`/Supplier/flight`);
  const handleClickOpen = () => {
    setOpen(true);
    LimpiarForm();
  };
  const handleClose = () => {
    setOpen(false);
    LimpiarForm();
  };
  const handleChangeRedondo = () =>{
    setRedondo(!redondo);
  };
  const onGuardar = () => {
    if (destino.IdCodigo > 0 && origen.IdCodigo > 0) {
      setIsload(true);
      let payloadCatalog = {
        IdOrigen: origen.IdCodigo,
        IdDestino: destino.IdCodigo,
      };
      dispatch(altaVueloCatalogoAction(payloadCatalog)).then((Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break;
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break;
          default:
            let vuelo = {
              IdPaquete: IdPaquete,
              IdVuelo: Response.data,
              Redondo: (redondo) ? 1 : 0, 
              ClaveProveedor: proveedor,
              ClavePaquete: ClavePaquete,
            };
            dispatch(altaPaqueteVueloAction(vuelo)).then((Response) => {
              switch (Response.status) {
                default:
                  LimpiarForm();
                  setOpen(false);
                  dispatch(obtenerVuelosByIdPaqueteAction(IdPaquete));
                  ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                  });
                  setIsload(false);
                  break;
              }
            });
            break;
        }
      });
    }
  };
  const handleSelectProveedor = (event) => {
    setProveedor(event.target.value);
  }
  const LimpiarForm = () => {
    setProveedor("")
    setRedondo(false);
    setDestino({ IdCodigo: 0 });
  };
  return (
    <div>
      <Tooltip title="Agregar vuelo">
        <span>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpen}
            disabled={origen.IdCodigo > 0 ? false : true}
          >
            <AddCircleOutlineIcon />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Nuevo vuelo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seleccione un destino para el vuelo a {origen.Descripcion}
          </DialogContentText>
          <Grid container>
            <Grid item xs={12}>
              <AutoInputIATA
                label="Destino"
                name="destino"
                data={catalogoIATA}
                setTarget={setDestino}
              />
            </Grid>
            <Grid item xs={12}>
                <FormControl
                  variant="outlined"
                  style={{width: "97%", margin: "5px"}}
                >
                  <InputLabel id="lTArerolina2">Aerolinea</InputLabel>
                  <Select
                    labelId="lTArerolina2"
                    id="sAerolinea2"
                    name="aerolinea"
                    value={proveedor}
                    onChange={handleSelectProveedor}
                    label="Aerolinea"
                  >
                    <MenuItem value="" disabled>
                      {"Seleccione una opción"}
                    </MenuItem>
                    {catProveedores.map((item, index) => (
                      <MenuItem key={item.IdProveedor} value={item.Nombre}>
                        {`${item.Nombre} - ${item.RazonSocial}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                style={{
                  margin: "2px 5px"
                }}
                control={
                  <Checkbox
                    checked={redondo}
                    onChange={handleChangeRedondo}
                    name="Redondo"
                    color="primary"
                  />
                }
                label="Redondo"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onGuardar}
            color="primary"
            disabled={destino.IdCodigo > 0 && proveedor !== "" ? false : true}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
      <BackDrop open={isLoad} />
    </div>
  );
};
export default AltaVuelo;
